import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { smallImage } from "../../../constants/image-constant";

const CommingSoonDetail = ({bodyType = "", fullScreenGallery = false, carImage }) => {
    const imageSrc = smallImage[bodyType.toLowerCase()] || smallImage.sedan;

    return (
        <div  styleName={`styles.imageWrap ${fullScreenGallery ? "styles.fullScreenGallery" : ""}`} >
            <img src={carImage || imageSrc} styleName="styles.carImage"/>
        </div>
    );
};

CommingSoonDetail.propTypes = {
    bodyType: PropTypes.string,
    carImage: PropTypes.string,
    fullScreenGallery: PropTypes.bool
};

export default CommingSoonDetail;
